import src from "IMAGE";
export default { src, width: 1171, height: 874, blurWidth: 0, blurHeight: 0};
